import { useAccountUpdateIpRangesMutation } from '~/generated/graphql';

export function useUpdateIpRanges() {
  const [
    updateIpRanges,
    { loading: updateIpRangesLoading },
  ] = useAccountUpdateIpRangesMutation();

  return {
    updateIpRanges,
    updateIpRangesLoading,
  };
}
